import React from 'react'

import { buildComponent } from '../../../../components/factory'

import * as UI from '@mantine/core'
import * as Routing from 'wouter'
import * as Icons from '../../../../components/icons'

export const Title = buildComponent().withRender(() => (
  <UI.Group
    mx={-16}
    px={16}
    mt={-16}
    py={16}
    sx={{
      position: 'sticky',
      top: 72,
      zIndex: 10,
      backgroundColor: '#f8f9fc',
    }}
  >
    <Routing.Link to="/categories">
      <UI.ActionIcon color="blue" size="xl" component="a">
        <Icons.FontAwesomeIcon size="lg" icon={Icons.Solid.faArrowLeft} />
      </UI.ActionIcon>
    </Routing.Link>
    <UI.Stack spacing={0}>
      <UI.Stack spacing={0}>
        <UI.Title>
          <UI.Text size={22}>Créer une catégorie</UI.Text>
        </UI.Title>
        <UI.Text color="dimmed">
          Créez une nouvelle catégorie pour organiser vos contenus audio.
        </UI.Text>
      </UI.Stack>
    </UI.Stack>
  </UI.Group>
))
